import styles from "../Editor.module.scss";

const ParagraphBlock = ({text}) => {
    return <p className={styles.reParagraph} dangerouslySetInnerHTML={{__html: text}} />;
};

export default ParagraphBlock;
